module.exports = __webpack_public_path__ + "static/media/chat-bubble.de8200e9.png";